// extracted by mini-css-extract-plugin
module.exports = {"selectButton":"NewOrderMethodSelectButton_selectButton___K3DG","selected":"NewOrderMethodSelectButton_selected__idTVt","heatApp":"NewOrderMethodSelectButton_heatApp__IgoKk"};